import './styles/index.css';
import './styles/flatpicker.css';
import './styles/custom-flatpicker.css';
import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from './core/redux/store';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </>
);
